<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">Brand Categories Commonly Reviewed</h1>

        <section class="content-section">
            <p class="desc-text">Brand references are provided solely to identify categories of products that may be reviewed through independent authentication procedures.</p>
            <p class="desc-text">XigCheck is not affiliated with, endorsed by, or officially authorized by the listed brands unless explicitly stated otherwise.</p>
            <p class="desc-text">XigCheck authentication review services may support selected luxury and fashion brands through independent authentication procedures and authentication partner support.</p>
            <p class="desc-text">Brand coverage availability may vary depending on independent authentication partner support, review feasibility, category risk controls, and marketplace compliance requirements.</p>
            <p class="desc-text">Examples of product brands that may appear within marketplace review categories include:</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Fashion &amp; Leather Goods</h2>
            <ul class="policy-list">
                <li>Louis Vuitton</li>
                <li>Chanel</li>
                <li>Hermès</li>
                <li>Gucci</li>
                <li>Dior</li>
                <li>Prada</li>
                <li>Fendi</li>
                <li>Saint Laurent</li>
                <li>Bottega Veneta</li>
                <li>Balenciaga</li>
                <li>Goyard</li>
                <li>Celine</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Accessories &amp; Jewelry</h2>
            <ul class="policy-list">
                <li>Cartier</li>
                <li>Tiffany &amp; Co.</li>
                <li>Van Cleef &amp; Arpels</li>
                <li>Bulgari</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Watches</h2>
            <ul class="policy-list">
                <li>Rolex</li>
                <li>Omega</li>
                <li>Tag Heuer</li>
                <li>Breitling</li>
                <li>Audemars Piguet</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Sneakers &amp; Collectible Fashion</h2>
            <ul class="policy-list">
                <li>Nike</li>
                <li>Adidas</li>
                <li>Jordan</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">Luxury Eyewear</h2>
            <ul class="policy-list">
                <li>Ray-Ban</li>
                <li>Dita</li>
                <li>Gentle Monster</li>
            </ul>
        </section>

        <section class="content-section">
            <p class="desc-text">Additional brands and categories may be introduced periodically based on marketplace demand and authentication partner support.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckBrandCategories'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
